import React, { Component } from 'react';
import _ from 'lodash';

import LoginSession from '../../../stores/LoginSession';

class DocumentActions extends Component {
  constructor(props){
    super(props)

    this.renderAction = this.renderAction.bind(this);
  }

  renderAction(action, index){
    const action_name = action.attributes.action_name;
    const action_class_name = action.attributes.action_class_name;

    return (
      <button key={index} 
              type='button' 
              disabled={this.props.clicked}
              className={`btn btn-sm ${action_class_name} mr-2 mb-2`}
              onClick={() => this.props.onActionClick(action_name)}>
        {action_name}
      </button>
    )
  }

  render(){
    const document = this.props.document;
    const workflow_process = this.props.workflow_process;
    let available_actions = workflow_process.attributes.available_actions;
    const current_state_name = _.get(workflow_process, "attributes.current_workflow_state.attributes.state_name");
    const status = _.get(workflow_process, "attributes.status");

    const created_by_id = _.get(document, "attributes.created_by.id");

    const is_document_owner = (created_by_id === LoginSession.current.user.id);
    _.remove(available_actions, (action) => {
      return _.includes(["ยกเลิกเอกสาร"], action.attributes.action_name) && !is_document_owner;
    })
  
    const assignees = _.map(workflow_process.attributes.positions_users, (positions_user) => {
                        return positions_user.attributes.user_id
                      });
    const is_assignee = _.indexOf(assignees, LoginSession.current.user.id) !== -1;
    if(!is_assignee){
      _.remove(available_actions, (action) => {
        return action.attributes.action_name !== "ส่งต่อ (สั่งการเพิ่มเติม)";
      })
    }

    if(this.props.preview){
      _.remove(available_actions, (action) => {
        return action.attributes.action_name === "ร่างใบปะหน้า" || action.attributes.action_name === "ส่งตรวจทาน";
      })
    }

    return (
      <div className='text-lg-right'>
        { (
            (current_state_name === "ร่างเอกสาร") || 
            (current_state_name === "เอกสารส่งออก") || 
            (current_state_name === "จบการทำงาน")
          ) && (
          <button type='button' className={`btn btn-sm btn-warning mr-2 mb-2 d-none d-lg-inline`} onClick={() => this.props.onActionClick("คัดลอก")}>
            คัดลอก
          </button>
        )}

        {is_document_owner && current_state_name === "เอกสารส่งออก" &&  status !== "Archived" && (
          <button type='button' className={`btn btn-sm btn-success mr-2 mb-2`} onClick={() => this.props.onActionClick("จัดเก็บเอกสาร")}>
            จัดเก็บเอกสาร
          </button>
        )}

        {this.props.preview && (
          <button type='button' className={`btn btn-sm btn-success mr-2 mb-2`} onClick={() => this.props.onActionClick("ดำเนินการต่อ")}>
            ดำเนินการต่อ
          </button>
        )}

        {this.props.isSecretary && current_state_name === "รอลงนาม" && (
          <button type='button' className={`btn btn-sm btn-danger mr-2 mb-2`} onClick={() => this.props.onActionClick("ส่งกลับผู้ร่าง")}>
            ตีกลับ
          </button>
        )}

        {this.props.isSecretary && current_state_name === "รอลงนาม (ใบปะหน้า)" && (
          <button type='button' className={`btn btn-sm btn-danger mr-2 mb-2`} onClick={() => this.props.onActionClick("ส่งกลับผู้ร่าง")}>
            ตีกลับ
          </button>
        )}

        {this.props.isSecretary && current_state_name === "รอเกษียน" && (
          <button type='button' className={`btn btn-sm btn-danger mr-2 mb-2`} onClick={() => this.props.onActionClick("ส่งกลับเจ้าของเรื่อง")}>
            ตีกลับ
          </button>
        )}

        {!_.isEmpty(available_actions) && _.map(available_actions, this.renderAction)}

        <button type='button' className={`btn btn-sm btn-secondary mr-2 mb-2`} onClick={() => this.props.onActionClick("โหลดเอกสารอีกครั้ง")}>
          โหลดเอกสารอีกครั้ง
        </button>
        
        <button type='button' className={`btn btn-sm btn-secondary mr-2 mb-2`} onClick={() => this.props.onActionClick("กลับ")}>
          กลับ
        </button>
      </div>
    )
  }
}

export default DocumentActions;




// WEBPACK FOOTER //
// ./src/components/documents/actions/DocumentActions.js